/* eslint-disable react/no-array-index-key */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

// Components
import Toast from './Toast';

import style from './Toaster.module.css';

const Toaster = ({ toasts, onToastClose, closePicto }) => (typeof document !== 'undefined'
  ? ReactDOM.createPortal(
    <div className={style.toaster}>
      {toasts.map(({
        id, title, content, color = 'grey', isSelfClosing = false, selfClosingTiming = 3000,
      }) => (
        <Toast
          key={id}
          title={title}
          content={content}
          color={color}
          closePicto={closePicto}
          isSelfClosing={isSelfClosing}
          onToastClose={() => onToastClose(id)}
          selfClosingTiming={selfClosingTiming}
        />
      ))}
    </div>,
    document.body,
  )
  : null);

Toaster.propTypes = {
  toasts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string,
    content: PropTypes.string,
    isSelfClosing: PropTypes.bool,
    color: PropTypes.oneOf(['primary', 'secondary', 'accent', 'success', 'error', 'warning', 'grey']),
    selfClosingTiming: PropTypes.number,
  })).isRequired,
};

export default Toaster;
